module.exports = __webpack_public_path__ + "static/media/icon_clear.4b783181.svg";